import { NavLink } from 'react-router-dom';
import { X } from 'lucide-react';
import clsx from 'clsx';
import { APP_NAV, NAV } from './nav';
import logoSrc from '@/images/Resstologo2.png';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function Sidebar({ open, onClose }: Props) {
  return (
    <>
      {/* Затемнение под mobile drawer */}
      <div
        className={clsx(
          'fixed inset-0 z-40 bg-ink/40 backdrop-blur-sm transition-opacity md:hidden',
          open ? 'opacity-100' : 'pointer-events-none opacity-0',
        )}
        onClick={onClose}
        aria-hidden="true"
      />

      <aside
        className={clsx(
          'fixed inset-y-0 left-0 z-50 w-[82%] max-w-[280px] shrink-0 border-r border-line bg-white',
          'transition-transform duration-200 ease-out',
          open ? 'translate-x-0' : '-translate-x-full',
          // На десктопе всегда видна, переходы выключаем
          'md:static md:w-64 md:translate-x-0 md:transition-none',
        )}
        aria-label="Навигация"
      >
        <div className="flex h-16 items-center border-b border-line px-5">
          <img
            src={logoSrc}
            alt="Resstro"
            className="h-7 w-auto select-none"
            draggable={false}
          />
          <span className="ml-3 rounded-sm bg-ink px-1.5 py-[2px] text-[10px] font-medium uppercase tracking-[0.14em] text-white">
            Platform
          </span>
          <button
            type="button"
            onClick={onClose}
            className="ml-auto grid h-9 w-9 place-items-center text-ink/60 hover:text-ink md:hidden"
            aria-label="Закрыть меню"
          >
            <X size={18} strokeWidth={1.75} />
          </button>
        </div>

        <nav className="p-3">
          <div className="mb-2 px-3 text-[10px] font-medium uppercase tracking-[0.14em] text-ink/40">
            Операции
          </div>
          <ul className="space-y-[2px]">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === '/'}
                  onClick={onClose}
                  className={({ isActive }) =>
                    clsx(
                      'group flex items-center gap-3 border-l-2 px-3 py-2.5 text-[14px] md:py-2 md:text-[13px] transition',
                      isActive
                        ? 'border-orange bg-orange-50/60 text-ink font-medium'
                        : 'border-transparent text-ink/70 hover:bg-paper hover:text-ink',
                    )
                  }
                >
                  <item.icon size={16} strokeWidth={1.75} />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="mb-2 mt-5 px-3 text-[10px] font-medium uppercase tracking-[0.14em] text-ink/40">
            Приложение People
          </div>
          <ul className="space-y-[2px]">
            {APP_NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  onClick={onClose}
                  className={({ isActive }) =>
                    clsx(
                      'group flex items-center gap-3 border-l-2 px-3 py-2.5 text-[14px] md:py-2 md:text-[13px] transition',
                      isActive
                        ? 'border-orange bg-orange-50/60 text-ink font-medium'
                        : 'border-transparent text-ink/70 hover:bg-paper hover:text-ink',
                    )
                  }
                >
                  <item.icon size={16} strokeWidth={1.75} />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
}
